import {InputCheckbox} from './InputCheckbox';

export default InputCheckbox;
